/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDrawerNavChildToggle.js
 *
 * ドロワーメニューの子メニュートグル
 * スマホでタップした時に--activeクラスを追加/削除
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ドロワーメニューの子メニュートグル
 */
const setDrawerNavChildToggle = () => {
	const childToggles = document.querySelectorAll('.site-header__drawer-nav .child-toggle');

	childToggles.forEach((toggle) => {
		toggle.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			const parentItem = this.closest('.item.has-child');
			if (parentItem) {
				parentItem.classList.toggle('--active');
			}
		});
	});
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setDrawerNavChildToggle };
